const _temp0 = require("../_shared/tag/localDevelopment.view.less");
module.exports = {
  "less": _temp0
}